import { render } from "./DocumentsIcon.vue?vue&type=template&id=2f127fda"
import script from "./DocumentsIcon.vue?vue&type=script&lang=js"
export * from "./DocumentsIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__